export default {
	capabilities: [],
	totalCapacity: 0,
	listSelectedCapacities: [],
	checkedCapacities: [],
	currentCapacity: {},
	currentCapacityId: 0,
	capacityIds: [],
};
